import {FC, SVGProps} from 'react';
import {BillsIcon, CardIcon} from '@rocket-ui/icons';
import {ForeignAccountPaymentIcon, PhonePaymentIcon} from 'shared/assets/icons';
import {RegistrationPaymentMethod} from './paymentMethod';

export const PAYMENT_METHOD_ICONS: Record<RegistrationPaymentMethod, FC<SVGProps<SVGSVGElement>>> = {
	sbp_account: PhonePaymentIcon,
	bank_card: CardIcon,
	executor_account: BillsIcon,
	'executor_account/swift': ForeignAccountPaymentIcon,
};
